import { ApolloError } from 'apollo-client';
import { parseISO } from 'date-fns';

import useTypedSWR from 'src/components/general/useTypedSWR';
import { PRESCRIPTION_TASKS_QUERY } from 'src/prescriptionTasksQueue/hooks/usePrescriptionTasks.gql';
import { PrescriptionTask } from 'src/prescriptionTasksQueue/types';

export const usePrescriptionTasks = (): {
  prescriptionTasks: PrescriptionTask[] | null;
  isLoading: boolean;
  error: ApolloError | undefined;
} => {
  const { data, isLoading, error } = useTypedSWR([PRESCRIPTION_TASKS_QUERY, {}], {
    revalidateOnFocus: false,
  });

  return {
    prescriptionTasks:
      data?.staff_getAllPrescriptionTasks.map(task => ({
        ...task,
        patientId: task.patient.id,
        createdAt: parseISO(task.createdAt),
      })) ?? null,
    isLoading,
    error,
  };
};
